export default __webpack_public_path__ + "static/media/p3.f39bc581.jpg";